import { ApiClient, TOKENS_REFRESH_ENDPOINT, UnAuthApiClient } from '@/services/api.service';
import { MyProfile, Photo, VerificationStatus, type Profile } from '@/types/profile';
import { jwtService } from '@/services/jwt.service';
import { UpdateLangProficiency } from '../lang/types';
import { SignUpDesign } from '@/store/useSignUpDesign';

class AuthApi {
    async getProfile() {
        const data = await ApiClient.get<Profile>(`/profile/`, {}).catch((error) => {
            const status = error.response ? error.response.status : null;

            // Пока проверка на 403 ошибку
            if (status === 403 && !error.response.data.is_banned) {
                alert('Внутренняя ошибка');
            } else {
                return error.response;
            }
        });

        return data;
    }

    async updatedProfile(updateUserDataDto: Partial<UpdatedProfile>) {
        const data = await ApiClient.patch<UpdatedProfile>(`/profile/`, {
            profile: updateUserDataDto,
        });
        return data;
    }

    async logout() {
        //await ApiClient.post('/auth/logout');
        jwtService.destroyTokenPair();
    }

    async completeRegistration() {
        const data = await ApiClient.patch<any>(`/registration/complete/`, );
        return data;
    }

    async partiallyCompleteRegistration() {
        const data = await ApiClient.patch<{ profile: MyProfile }>(`/registration/skip/`, );
        return data;
    }

    async requestOTP(payload: RequestOtpPayload) {
        const data = await UnAuthApiClient.post<{ countdown: number }>('/registrations/', payload);
        return data;
    }

    async verifyOTP(email: string, code: string) {
        const data = await UnAuthApiClient.post<VerifyOtpResponse>('/sessions/', { email, code });
        return data;
    }

    async invalidateTokens(token: string) {
        const data = await UnAuthApiClient.post<VerifyOtpResponse>(TOKENS_REFRESH_ENDPOINT, { refresh_token: token });
        return data;
    }
}

export const authApi = new AuthApi();

export type RequestOtpPayload = {
    profile: {
        email: string,
        lang: string,
        source?: string
    }
}

interface UpdatedProfile {
    id: number;
    about_me: string;
    dob: string | null;
    email: string | null;
    gender?: 'male' | 'female';
    looks_for: 'male' | 'female' | 'any' | null;
    max_age: number | null;
    min_age: number | null;
    public_name: string | null;
    purpose: 'love' | 'fun' | 'not_specified' | null;
    state: 'incomplete' | 'complete' | 'moderated' | 'half_done';
    travel_plans: string | null;
    region_ids: number[];
    is_online?: boolean;
    active?: boolean;
    expanded_age_search?: boolean;
    verification_status?: VerificationStatus;
    moderation_status: string;
    age?: number;
    lang: string;
    additional_info_attributes: Partial<{
        catch_my_interest: string;
        my_ideal_evening: string;
        height: number | null;
        marital_status:  'single' | 'divorced' | 'widowed' | 'not_specified';
        smoking: 'non-smoker' | 'smoker' | 'occasionally';
        drinking: 'non-drinker' | 'occasionally' | 'i_drink';
        children: 'none' | 'live_with_me' | 'live_separately';
        language_proficiency: string;
    }>
}

export type VerifyOtpResponse = {
    access_token: string
    refresh_token: string
}
